import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum FormSecurityRight {
    CanAccessForms = 26000,
    CreateEditForms = 26001,
    DeleteForms = 26002,
    ModifyAfterSubmission = 26003,
}

export class FormSecurityModule extends BaseSecurityModule<FormSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Forms,
            [
                { _id: FormSecurityRight.CanAccessForms, name: 'Access Forms', basic: true, subscription: TenantSubscription.Professional },
                { _id: FormSecurityRight.CreateEditForms, name: 'Create/Edit Forms', basic: false, subscription: TenantSubscription.Professional },
                { _id: FormSecurityRight.DeleteForms, name: 'Delete Forms ( Requires Create/Edit )', basic: false, subscription: TenantSubscription.Professional },
                { _id: FormSecurityRight.ModifyAfterSubmission, name: 'Modify After Submission', basic: false, subscription: TenantSubscription.Professional },
            ] as SecurityRight<FormSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;

    }
}
